import { useAppSelector } from "integrations/redux/hooks"
import { getSidePanelActiveFeaturePlugins } from "plugins/plugin-registry"
import { selectActiveFeatureId } from "./slice.new"

export function useSidePanelActiveFeatureData() {
    const sidePanelPlugins = getSidePanelActiveFeaturePlugins()
    const activeFeatureId = useAppSelector(selectActiveFeatureId)
    return sidePanelPlugins.find((plugin) => plugin.featureId === activeFeatureId)
}

export type SidePanelActiveFeaturePlugin = NonNullable<
    ReturnType<typeof useSidePanelActiveFeatureData>
>
